//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeSheets', {
//        templateUrl: 'views/components/views/timeSheets/timeSheets.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'timeSheetsService', function ($stateParams, timeSheetsService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;

//            vm.model = {
//                itemsListTimeSheets: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenuTimeSheets() {
//                vm.model.itemsListTimeSheets = await timeSheetsService.listMenuTimeSheets({ labour_no: labourNo });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadMenuTimeSheets();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
